import { Button } from '@/components/ui/button';
import { DeleteAccountDialog } from '@/components/auth/DeleteAccountDialog';

export function DataPrivacySection() {
  return (
    <section className="rounded-xl border border-telekinesis-neutral-800 bg-telekinesis-background-2 p-6">
      <h2 className="mb-5 text-sm font-medium text-telekinesis-neutral-50">
        Data and privacy
      </h2>

      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="text-sm text-telekinesis-neutral-50">
            Delete account
          </div>
          <div className="mt-0.5 text-xs leading-relaxed text-telekinesis-neutral-200">
            Permanently delete your account and all associated data.
          </div>
        </div>
        <DeleteAccountDialog>
          <Button
            className="flex-shrink-0 rounded-full font-light"
            variant="destructive"
          >
            Delete
          </Button>
        </DeleteAccountDialog>
      </div>
    </section>
  );
}
